module.exports = __webpack_public_path__ + "img/qiyeweixin_circle.cd62938b.png";